import React from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { VPSPlans } from '../components/VPSPlans';
import { GameHostingPreview } from '../components/GameHostingPreview';
import { About } from '../components/About';

export function HomePage() {
  return (
    <div>
      <Hero />
      <Features />
      <VPSPlans />
      <GameHostingPreview />
      <About />
    </div>
  );
}